/**
 * SEO Component
 * Dynamic meta tags for each page using react-helmet-async
 */

import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT = {
  title: 'AnchorPals - Your Crew at Every Port',
  description: 'Connect with verified local mooring helpers at 500+ ports worldwide. Real-time assistance, trusted reviews, and in-app chat for yacht owners.',
  image: 'https://anchorpals.com/og-image.jpg',
  url: 'https://anchorpals.com',
};

function SEO({ title, description, path, noindex }) {
  const pageTitle = title ? `${title} | AnchorPals` : DEFAULT.title;
  const pageDescription = description || DEFAULT.description;
  const pageUrl = path ? `${DEFAULT.url}${path}` : DEFAULT.url;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={pageUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={DEFAULT.image} />

      {/* Twitter */}
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
    </Helmet>
  );
}

export default SEO;
